// export const domain = 'http://localhost/fftt-pro';
export const domain = 'https://www.fftt.com/pro';
// export const domain = 'https://www.fftt.com/pro_dev_20250211';


// Environnement du web service livescore (dafunker)
// 0 = production, 1 = préprod
export const IS_PREPROD = 0;

// URL et port du web service livescore selon l'environnement
export const URL_WS_URL = IS_PREPROD === 1
    ? 'http://preprod.fftt.dafunker.com'
    : 'https://fftt.dafunker.com';

export const URL_WS_PORT = IS_PREPROD === 1 ? 2091 : 3000;


// Listes des clubs par championnats
export const listClubProam = [];
export const listClubProbm = [];
export const listClubProad = [];
export const listClubProbd = [];

export const getLongNameChamp = (value) => {
    switch (value) {
        case 'proam':
            return 'Pro A Messieurs';
        case 'probm':
            return 'Pro B Messieurs';
        case 'proad':
            return 'Pro A Dames';
        case 'probd':
            return 'Pro B Dames';
        case 'preprod':
            return 'Préprod';
        default:
            break;
    }
} 

export const getCorrectListClub = (value) => {
    switch (value) {
        case 'proam':
            return listClubProam;
        case 'probm':
            return listClubProbm;
        case 'proad':
            return listClubProad;
        case 'probd':
            return listClubProbd;
        default:
            break;
    }
}

// ST-DENIS US 93 TT 1

export const apiLink = [
    {id: 1, link: 'https://www.fftt.com/mobile/pxml/xml_result_equ.php?serie=000000000000033&id=AF001&tm=20220126151727436&tmc=b9871a42ebfd846e2204fa9c232afc73f03580b1&force=1&D1=247759&splat=xml_result_equ.php', for: 'proam'},
    {id: 2, link: 'https://www.fftt.com/mobile/pxml/xml_result_equ.php?serie=000000000000033&id=AF001&tm=20220126151727436&tmc=b9871a42ebfd846e2204fa9c232afc73f03580b1&force=1&D1=247760&splat=xml_result_equ.php', for: 'probm'},
    {id: 3, link: 'https://www.fftt.com/mobile/pxml/xml_result_equ.php?serie=000000000000033&id=AF001&tm=20220126151727436&tmc=b9871a42ebfd846e2204fa9c232afc73f03580b1&force=1&D1=247761&splat=xml_result_equ.php', for: 'proad'},
    {id: 4, link: 'https://www.fftt.com/mobile/pxml/xml_result_equ.php?serie=000000000000033&id=AF001&tm=20220126151727436&tmc=b9871a42ebfd846e2204fa9c232afc73f03580b1&force=1&D1=247762&splat=xml_result_equ.php', for: 'probd'},
]

export const classementAPI = [
    {id: 1, link: "https://apiv2.fftt.com/mobile/pxml/xml_result_equ.php?serie=123456789012345&tm=20200910&tmc=18821f4bf4bfcdb1b9db879ebbba80230a686cce&id=TEST&D1=247759&action=classement", for: 'proam'},
    {id: 2, link: "https://apiv2.fftt.com/mobile/pxml/xml_result_equ.php?serie=123456789012345&tm=20200910&tmc=18821f4bf4bfcdb1b9db879ebbba80230a686cce&id=TEST&D1=247760&action=classement", for: 'probm'},
    {id: 3, link: "https://apiv2.fftt.com/mobile/pxml/xml_result_equ.php?serie=123456789012345&tm=20200910&tmc=18821f4bf4bfcdb1b9db879ebbba80230a686cce&id=TEST&D1=247761&action=classement", for: 'proad'},
    {id: 4, link: "https://apiv2.fftt.com/mobile/pxml/xml_result_equ.php?serie=123456789012345&tm=20200910&tmc=18821f4bf4bfcdb1b9db879ebbba80230a686cce&id=TEST&D1=247762&action=classement", for: 'probd'},
]

